import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import BootstrapVue from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faInfoCircle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import VueAxios from "vue-axios";
import VueOffline from "vue-offline";
import VueSweetalert2 from "vue-sweetalert2";
import ToggleButton from "vue-js-toggle-button";
import Vuebar from "vuebar";
import * as erroHan from "./error-handling";
import * as helper from "./helper";
import * as SlackNotifications from "./SlackNotifications";
import helperMixin from "./mixins/helper-mixin";
import "./custom-directives";
import "./events";
import "./socket";
import "./database";
import "./registerServiceWorker";

// let showAlert = false;

// axios.defaults.baseURL = "https://test.api.gozwing.com/";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// axios.defaults.baseURL = "http://localhost:8081/api/public";
// axios.defaults.baseURL = 'http://localhost:8008/zwingp/api/public';
// axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// axios.defaults.baseURL = "http://localhost/api/public";
// axios.defaults.baseURL = 'https://prod2.api.gozwing.com/';
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// axios.defaults.baseURL = "https://dev.api.gozwing.com/";
// axios.defaults.baseURL = "http://192.168.1.48/api/public/";
// axios.defaults.baseURL = "http://192.168.1.139/api/public/";
// axios.defaults.baseURL = "http://192.168.29.240/api/public/";
// axios.defaults.baseURL = "http://192.168.1.200/api/public/";
// axios.defaults.baseURL = "http://192.168.43.165/api/public/";
// axios.defaults.baseURL = "http://192.168.1.14:8008/zwingp/api/public/";
// axios.defaults.baseURL = "https://api.gozwing.com/";

// Add a request interceptor
axios.interceptors.request.use(
  function(config) {
    globalLoading.$data.$loading = true;
    if (config.hasOwnProperty("data")) {
      config.data.trans_from = store.state.system.trans_from;
      config.data.udidtoken = store.state.system.licence;
      if (store.state.system.settings.hasOwnProperty("terminal_id")) {
        config.data.terminal_id = store.state.system.settings.terminal_id;
      }
      if (store.state.system.settings.hasOwnProperty("settlement")) {
        config.data.session_id =
          store.state.system.settings.settlement.settlement_session_id;
      }
    }
    if (store.state.system.licence != "" && store.state.system.settings != "") {
      if (
        store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        store.state.system.settings.vendor_app_menu.offline.status == 1 &&
        store.state.system.forceOffline == true
      ) {
        config.baseURL = "https://cool";
      }
    }
    if (config.hasOwnProperty("url")) {
      helper.billingModeFilter(config);
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    globalLoading.$data.$loading = false;
    if (store.state.system.licence != "" && store.state.system.settings != "") {
      if (
        store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        store.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        helper.offlineAPI(response, "online");
      }
    }

    if (response.status == 200 && response.data.status == "fail")
      erroHan.failAlert(response);

    return response;
  },
  function(error) {
    globalLoading.$data.$loading = false;
    if (store.state.system.licence != "" && store.state.system.settings != "") {
      if (
        store.state.system.forceOffline == true &&
        store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        store.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        error.config.url = error.config.url.replace(
          "https://cool/",
          process.env.VUE_APP_API_URL
        );
        error.config.baseURL = process.env.VUE_APP_API_URL;
      }
    }

    if (store.state.system.isOffline == false) {
      SlackNotifications.fireNotification(error);
    }

    if (error.response) {
      erroHan.error(error.response);
    } else {
      if (
        store.state.system.licence != "" &&
        store.state.system.settings != ""
      ) {
        if (
          store.state.system.settings.vendor_app_menu.hasOwnProperty(
            "offline"
          ) &&
          store.state.system.settings.vendor_app_menu.offline.status == 1
        ) {
          return helper.offlineAPI(error, "offline");
        }
      } else if (
        store.state.system.licence != "" &&
        store.state.system.settings == ""
      ) {
        // if (
        //   store.state.system.settings.vendor_app_menu.hasOwnProperty(
        //     "offline"
        //   ) &&
        //   store.state.system.settings.vendor_app_menu.offline.status == 1
        // ) {
        return helper.offlineAPI(error, "offline");
        // }
      }
    }
    return Promise.reject(error);
  }
);

library.add(faUserSecret);
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(Vuebar);
// Vue.use(Vuelidate);
library.add(faUserSecret);
library.add(faInfoCircle);
library.add(faCheckCircle);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueOffline);
Vue.use(ToggleButton);
Vue.use(require("vue-moment"));
Vue.use(require("vue-shortkey"));
window.onunhandledrejection = function(event) {
  event.preventDefault();
  let reason = event.reason;
  console.warn(
    "Unhandled promise rejection:",
    reason && (reason.stack || reason)
  );
};

let globalLoading = new Vue({
  data: {
    $loading: false,
    $showMessage: store.state.message,
    $showAlert: false,
  },
});

// Vue.filter("commaSep", (num) => {
//   return Number(num).toLocaleString("en-US", {
//     minimumFractionDigits: 2,
//   });
// });

Vue.mixin({
  mixins: [helperMixin],
  data() {
    return {
      // db: db
    };
  },

  computed: {
    $loading: {
      get: function() {
        return globalLoading.$data.$loading;
      },
      set: function(newLoading) {
        globalLoading.$data.$loading = newLoading;
      },
    },
    $showMessage: {
      get: function() {
        return globalLoading.$data.$showMessage;
      },
      set: function(newLoading) {
        globalLoading.$data.$showMessage = newLoading;
      },
    },
    $showAlert: {
      get: function() {
        return globalLoading.$data.$showAlert;
      },
      set: function(newLoading) {
        globalLoading.$data.$showAlert = newLoading;
      },
    },
  },
});

let vm = new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    window.addEventListener("offline", () => {
      console.log("Offline");
      if (
        store.state.system.settings.hasOwnProperty("vendor_app_menu") &&
        store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        store.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        store.commit("system/forceOfflineStatus", false);
        store.commit("system/setConnected", true);
        store.dispatch("system/log", {
          type: "state_change_offline",
          log: {},
          status: "success",
          response: "",
        });
        helper.switchToOffline();
      } else {
        helper.checkPosStatus();
      }
    });
    window.addEventListener("online", () => {
      console.log("Online");
      if (
        store.state.system.settings.hasOwnProperty("vendor_app_menu") &&
        store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        store.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        store.commit("system/setConnected", false);
        store.dispatch("system/log", {
          type: "state_change_online",
          log: {},
          status: "success",
          response: "",
        });
        helper.verifyOfflineState();
      } else {
        helper.checkPosStatus("online");
      }
    });
  },
  mounted() {},
}).$mount("#app");

if (!process.env.VUE_APP_API_URL == "http://localhost/api/public/")
  console.log = function() {};

require("./styles/style.scss");
